class Extension {
  constructor(sipExtension, cityId) {
    this.sipExtension = sipExtension;
    this.cityId = cityId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allExtensions: [],
      extension: new Extension('', null),
      allExtensionsForOther: [],
    };
  },
  methods: {
    getListOfExtensionsForOther: function (cityId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllExtensionsWithCityId', cityId).then(() => {
        if (this.$store.state.extensionModule.successFlag) {
          this.allExtensionsForOther = this.$store.state.extensionModule.allExtensions;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.extensionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfExtensionsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.extensionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfExtensionsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfExtensions: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllExtensions').then(() => {
        if (this.$store.state.extensionModule.successFlag) {
          this.allExtensionsForOther = this.$store.state.extensionModule.allExtensions;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.extensionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfExtensions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.extensionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfExtensions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllExtensions: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllExtensions').then(() => {
        if (this.$store.state.extensionModule.successFlag) {
          let temp = this.$store.state.extensionModule.allExtensions;
          this.allExtensions = [];
          for (let i = 0; i < temp.length; i++) {
            this.allExtensions.push({
              counter: i + 1,
              city: temp[i].city ? temp[i].city.title : '-',
              sipExtension: temp[i].sipExtension ? temp[i].sipExtension : '-',
              id: temp[i].id,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.extensionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllExtensions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.extensionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllExtensions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addExtensionFunction: function () {
      if (!this.extension.sipExtension) {
        this.snackText = 'داخلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.extension.sipExtension.replace(/\s/g, '').length) {
        this.snackText = 'داخلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.extension.cityId) {
        this.snackText = 'َشهرستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addExtension', this.extension).then(() => {
        if (this.$store.state.extensionModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' داخلی با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.extension = new Extension('', null);
          this.getAllExtensions();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.extensionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addExtensionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.extensionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addExtensionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getExtensionFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getExtension', id).then(() => {
        if (this.$store.state.extensionModule.successFlag) {
          let temp = this.$store.state.extensionModule.extension;
          this.extension.id = temp.id;
          this.extension.sipExtension = temp.sipExtension;
          this.extension.cityId = temp.city.id;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.extensionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getExtensionFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.extensionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getExtensionFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editExtensionFunction: function () {
      if (!this.extension.sipExtension) {
        this.snackText = 'داخلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.extension.sipExtension.replace(/\s/g, '').length) {
        this.snackText = 'داخلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.extension.cityId) {
        this.snackText = 'شهرستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editExtension', this.extension).then(() => {
        if (this.$store.state.extensionModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllExtensions();
          this.snackText = ' داخلی با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.extension = new Extension('', null);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.extensionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editExtensionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.extensionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editExtensionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteExtensionFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteExtension', this.extensionId).then(() => {
        if (this.$store.state.extensionModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllExtensions();
          this.snackText = ' داخلی با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.extensionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteExtensionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.extensionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteExtensionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.extensionModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
